<!-- FIXME: if tenant -->
<ng-container *ngIf="tenant == 13 && this.tenantConfig.influxMeasurements">
  <qm-influx-graph
    #influxGraph
    [bucket]="this.tenantConfig.influxMeasurements.bucket"
    [measurement]="this.tenantConfig.influxMeasurements.measurement"
    [filterFields]="['tunnus', 'symboli', '_field']"
    [filterLabelFields]="{'tunnus': 'nimi', 'symboli': 'kuvaus'}"
    [filterDefaults]="{'_field': 'counter'}"
    windowField="_field"
  ></qm-influx-graph>
</ng-container>
<ng-container *ngIf="tenant === 14">
  <qm-neve-measurements></qm-neve-measurements>
</ng-container>
